import React from 'react';
import Styles from './Workflow.module.scss';

class Workflow extends React.Component {
  render = () => {
    return (
      <React.Fragment>
        {this.props.entity.approved === -1 ? (
          <React.Fragment>
            <ul className={Styles.workflow}>
              <li className={Styles.active}>
                <span className={Styles.circle}>1</span>
                <span className={Styles.label}>Submitted</span>
              </li>
              <li className={Styles.active}>
                <span className={Styles.circle}>2</span>
                <span className={Styles.label}>Denied</span>
              </li>
            </ul>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {this.props.chargeable === 1 ? (
              <ul className={Styles.workflow}>
                <li className={Styles.active}>
                  <span className={Styles.circle}>1</span>
                  <span className={Styles.label}>Submitted</span>
                </li>
                <li
                  className={
                    this.props.entity.approved === 1 ? Styles.active : ''
                  }
                >
                  <span className={Styles.circle}>2</span>
                  <span className={Styles.label}>Approved</span>
                </li>
                <li
                  className={
                    this.props.entity.qb_invoice_id !== null
                      ? Styles.active
                      : ''
                  }
                >
                  <span className={Styles.circle}>3</span>
                  <span className={Styles.label}>Invoiced</span>
                </li>
                <li
                  className={
                    this.props.entity.qb_invoice_paid === 1 ? Styles.active : ''
                  }
                >
                  <span className={Styles.circle}>4</span>
                  <span className={Styles.label}>Paid</span>
                </li>
                <li
                  className={
                    this.props.entity.status === 1 ? Styles.active : ''
                  }
                >
                  <span className={Styles.circle}>5</span>
                  <span className={Styles.label}>Delivered</span>
                </li>
              </ul>
            ) : (
              <ul className={Styles.workflow}>
                <li className={Styles.active}>
                  <span className={Styles.circle}>1</span>
                  <span className={Styles.label}>Submitted</span>
                </li>
                <li
                  className={
                    this.props.entity.approved === 1 ? Styles.active : ''
                  }
                >
                  <span className={Styles.circle}>2</span>
                  <span className={Styles.label}>Approved</span>
                </li>
                <li
                  className={
                    this.props.entity.status === 1 ? Styles.active : ''
                  }
                >
                  <span className={Styles.circle}>3</span>
                  <span className={Styles.label}>Delivered</span>
                </li>
              </ul>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };
}

export default Workflow;
